import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { COUNTRIES, Country } from '../modules/dora/constants/countries';

interface CountrySelectorProps {
  value: string;
  onChange: (countryCode: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  error?: boolean;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({
  value,
  onChange,
  label = "Country",
  required = false,
  disabled = false,
  helperText,
  error = false,
}) => {
  // Find the selected country object
  const selectedCountry = COUNTRIES.find(c => c.code === value) || null;

  return (
    <Autocomplete
      value={selectedCountry}
      onChange={(_, newValue: Country | null) => {
      onChange(newValue?.code || '');
    }}
    options={COUNTRIES}
    getOptionLabel={(option) => `${option.name} (${option.code})`}
    renderOption={(props, option) => (
      <li {...props} key={option.code}>
        <span style={{ marginRight: 8, fontSize: '1.2em' }}>{option.flag}</span>
        {option.name} ({option.code})
      </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          helperText={helperText}
          error={error}
          fullWidth
          InputProps={{
            ...params.InputProps,
            startAdornment: selectedCountry ? (
              <span style={{ marginLeft: 8, marginRight: 4, fontSize: '1.2em' }}>
                {selectedCountry.flag}
              </span>
            ) : null,
          }}
        />
      )}
      disabled={disabled}
      fullWidth
      isOptionEqualToValue={(option, value) => option.code === value?.code}
    />
  );
};

export default CountrySelector;
